var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTabArrow = function SvgIconTabArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9619 36.6777L37.1032 15.6057L35.0146 15.6197L34.8973 33.1206L24.3162 22.5395L2.35282 0.576107L0.860385 2.06854L22.8238 24.0319L33.4049 34.613L15.904 34.7303L15.89 36.8189L36.9619 36.6777Z",
    fill: "#301DCD"
  })));
};
export default SvgIconTabArrow;